<template>
  <section id="dashboard">
    <b-row class="match-height">
      <b-col
        lg="12"
        sm="12"
      >
        <user-plans-consulta />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="12"
        sm="12"
      >
        <user-plans-alterar />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import UserPlansConsulta from './UserPlansConsulta.vue'
import UserPlansAlterar from './UserPlansAlterar.vue'

export default {
  components: {
    BRow,
    BCol,
    UserPlansConsulta,
    UserPlansAlterar,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-company.scss';
</style>
